module.exports = __webpack_public_path__ + "media/images/reports/filter-6aac4d65b55b6d876dd31aac24663647.svg";